/** Frontmatter for the "week7-start-sit-darkness-report" article; the Body lives in week7-start-sit-darkness-report.jsx. */
const meta = {
  slug: 'week7-start-sit-darkness-report',
  title: 'Week 7 Start/Sit: The Darkness Report',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'All 14 games from Thursday night through Monday night, with Pittsburgh at New Orleans in Paris at 9:30am ET, one card each: start, flex and sit calls, game-time decision callouts, a slate board of lines and implied points, an injury board with inactive windows, a handcuff board, D/ST and IDP streamers, position tiers, the Darkness Rulings and the inactives checklist.',
  readMinutes: 42,
  date: '2026-10-22',
};

export default meta;
